import React, { Component } from "react";
import { Route, Switch, withRouter, Router } from "react-router-dom";
import { PATHS } from "./constant";
import { isAuthenticatedAsync } from "./helper";
import Login from "./container/authentication/Login";
import ResetPassword from "./container/authentication/ResetPassword";
import Registration from "./container/authentication/Registration";
import ServerError from "./component/ServerError";
import Front from "./container/front/Front";
import CommonLayout from "./component/CommonLayout";
import { connect } from "react-redux";
import store from "./store";
import { createBrowserHistory } from "history";
import httpService from "./axios-interceptor";
import SomethingWentWrong from "./component/SomethingWentWrong";
import { bindActionCreators } from "redux";
import { windowResize } from "./actions/common.action";
import LoginUserVerification from "./container/authentication/LoginUserVerification";
import LoginWithOTPWrapper from "./container/authentication/LoginWithOTPWrapper";
import BestPractices from "./container/BestPractices/BestPractices";
import GetOtp from "./container/profile/GetOtp";
import AccessDenied from "./container/AccessDenied";
import PrivateRoutes from "./routes/PrivateRoutes";
import UnderMaintenance from "./component/UnderMaintenance";
import ArticleDetail from "./container/articleDetail/ArticleDetail";
import PmgProject from "./component/PmgProject";
import AboutUs from "./container/front/AboutUs";
import ContactUs from "./container/front/ContactUs";
import FeedBackAndSuggestions from "./container/front/FeedBackAndSuggestions";
import SiteMap from "./container/front/SiteMap";
const history = createBrowserHistory();
httpService.setupInterceptors(store, history);

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthResolved: false,
      isAuthenticated: false
    };
  }

  handleWindowResize = () => {
    let {
      actions: { windowResize }
    } = this.props;
    windowResize();
  };

  async handleAuthenticationCheck() {
    let results = await isAuthenticatedAsync();
    this.setState({
      isAuthResolved: true,
      isAuthenticated: results
    });
  }

  componentDidMount() {
    this.handleAuthenticationCheck();
    this.handleWindowResize();
    window.addEventListener("resize", this.handleWindowResize);
  }

  render() {
    const {
      permissionsListing: { data }
    } = this.props;

    return (
      <Router history={history}>
        <Switch>
          {/* <Route exact path={PATHS.LOGIN} component={Login} /> */}
          <CommonLayout exact path={PATHS.LOGIN} component={Login} />
          <CommonLayout
            exact
            path={PATHS.BEST_PRACTICES}
            component={BestPractices}
          />
          <CommonLayout
            exact
            path={PATHS.LOGIN_WITH_PASSWORD}
            component={Login}
          />
          <CommonLayout
            exact
            path={PATHS.LOGIN_WITH_OTP}
            component={LoginWithOTPWrapper}
          />
          <CommonLayout
            exact
            path={PATHS.RESET_PASSWORD}
            component={ResetPassword}
          />
          <CommonLayout exact path={PATHS.SIGNUP} component={Registration} />
          {/* <CommonLayout
            exact
            path={PATHS.TERMS_CONDITIONS}
            component={TermsConditions}
          />
          <CommonLayout
            exact
            path={PATHS.PRIVACY_POLICY}
            component={PrivacyPolicy}
          /> */}
          <CommonLayout exact path={PATHS.HOME} component={Front} />
          <Route exact path={PATHS.PMG_PROJECT_DETAIL} component={PmgProject} />
          <CommonLayout
            exact
            path={PATHS.SOMETHING_WENT_WRONG}
            component={SomethingWentWrong}
          />
          <CommonLayout
            exact
            path={PATHS.UNDER_MAINTENANCE}
            component={UnderMaintenance}
          />
          <CommonLayout
            exact
            path={PATHS.SERVER_ERROR}
            component={ServerError}
          />
          <CommonLayout
            exact
            path={PATHS.ACCESS_DENIED}
            component={AccessDenied}
          />
          <CommonLayout
            exact
            path={`${PATHS.ARTICLES_DETAILS_PAGE}/:id`}
            component={ArticleDetail}
          />
          <CommonLayout exact path={PATHS.ABOUT_US_PAGE} component={AboutUs} />
          <CommonLayout
            exact
            path={PATHS.CONTACT_US_PAGE}
            component={ContactUs}
          />
          <CommonLayout
            exact
            path={PATHS.FEEDBACK_PAGE}
            component={FeedBackAndSuggestions}
          />
          <CommonLayout exact path={PATHS.SITEMAP} component={SiteMap} />
          <PrivateRoutes />
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  permissionsListing: state.commonReducer.permissionsListing
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      windowResize
    },
    dispatch
  )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Routes)
);
